








































import Vue from "vue";
export default Vue.extend({
    props: {
        locale: {
            type: String,
            required: true,
        },

        isCurrent: {
            type: Boolean,
            required: true,
        },

        valid: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
});
